
import AnimatedSection from '../../../components/base/AnimatedSection';

export default function Testimonios() {
  return (
    <section className="py-20 bg-gray-950">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 text-center">
              Testimonios
            </h2>
            <p className="text-xl text-gray-300 mb-12 text-center">
              Lo que dicen quienes ya participaron
            </p>
          </AnimatedSection>
          <AnimatedSection animation="scaleUp" delay={150}>
            <div className="flex justify-center">
              <div className="w-full max-w-xl">
                <div className="relative w-full aspect-square rounded-2xl overflow-hidden shadow-2xl shadow-teal-500/20 border border-gray-800">
                  <iframe
                    src="https://www.youtube.com/embed/CkjJ3LTMaZM"
                    width="100%"
                    height="100%"
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="absolute inset-0 w-full h-full"
                    title="Testimonio de participante"
                  ></iframe>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
